import I18n from 'i18n-js';
import React from 'react';
import { useInRouterContext, useNavigate } from 'react-router';

import SiteSearch from './site_search';
import ReverbSiteSearchSuggestions from './reverb_site_search_suggestions';
import ReverbSiteSearchController from './reverb_site_search_controller';
import { IUrl } from '../../url_context';
import { IUser } from '../user_context_provider';
import Suggestion from './suggestion';

export interface ISiteBanner {
  saleUrl: string;
  heading: string;
}

interface IProps {
  defaultValue: string;
  siteBanner?: ISiteBanner;
  placeholder?: string;
  rounded?: boolean;
  url?: IUrl;
}

export default function ReverbSiteSearch(props: IProps) {
  const inRouterContext = useInRouterContext();
  // `useNavigate` throws when called outside an ancestor `<RouterProvider>`.
  // Whether this component is inside a router is fixed by where it's
  // mounted, so this doesn't change across re-renders of the same instance
  // -- which makes calling this conditionally safe here in practice, even
  // though it isn't statically provable by the hooks lint rule (same
  // pattern used by CoreLink and Redirect).
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const navigate = inRouterContext ? useNavigate() : undefined;

  return (
    <SiteSearch
      fetchSuggestions={ReverbSiteSearchSuggestions.fetch}
      submitQuery={(user: IUser, query: string, suggestions: Suggestion[], lastTypedValue: string) =>
        ReverbSiteSearchController.submitQuery(user, query, suggestions, lastTypedValue, navigate)}
      selectSuggestion={(user: IUser, suggestion: Suggestion, suggestions: Suggestion[], lastTypedValue: string) =>
        ReverbSiteSearchController.selectSuggestion(user, suggestion, suggestions, lastTypedValue, navigate)}
      defaultValue={props.defaultValue}
      siteBanner={props.siteBanner}
      placeholderText={props.placeholder || I18n.t('commons.siteSearch.placeholder')}
      rounded={props.rounded}
      url={props.url}
    />
  );
}
